module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-toright-d3da27a32fba6c3f3104593637803c35.svg";